import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28,6H4A2,2,0,0,1,4,2H28a2,2,0,0,1,0,4Z"/><path d="M21,14H4a2,2,0,0,1,0-4H21a2,2,0,0,1,0,4Z"/><path d="M28,22H4a2,2,0,0,1,0-4H28a2,2,0,0,1,0,4Z"/><path d="M15,30H4a2,2,0,0,1,0-4H15a2,2,0,0,1,0,4Z"/>';
export var TextLeftAlignedSVG = function TextLeftAlignedSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextLeftAlignedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextLeftAlignedSVG);